import React, { FC } from 'react';
import { Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import { parseIndividualReportIntroduction } from '../../../../helpers/helpers';
import { THEME as theme } from '../../../../styles/theme';
import PageCount from '../../components/PageCount/PageCount';
import PageSection from '../../components/PageSection/PageSection';

const styles = StyleSheet.create({
  page: {
    position: 'relative',
    fontFamily: 'Roboto-Regular',
    backgroundColor: theme.colors.neutral.secondary,
  },
  title: {
    fontFamily: 'Roboto-Bold',
    fontSize: 12,
    fontWeight: 700,
    marginBottom: theme.layout.spacing.nano,
  },
});

interface IIntroductionPage {
  introduction: string;
}

const IntroductionPage: FC<IIntroductionPage> = ({ introduction }) => {
  const { t } = useTranslation();

  const parsedIntroduction = parseIndividualReportIntroduction(introduction);

  return (
    <Page id="introduction" orientation="portrait" size="A4" style={styles.page} wrap={false}>
      <PageSection title={t('results.report.pdf.sections.introduction')}>
        {parsedIntroduction.map(({ title, text }, index) => (
          <View key={index}>
            {title ? <Text style={styles.title}>{title}</Text> : null}
            <Text>{text}</Text>
          </View>
        ))}
      </PageSection>
      <PageCount />
    </Page>
  );
};

export default IntroductionPage;
